var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPendingCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#0E72ED",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 14.5C9.724 14.5 9.50032 14.2763 9.50032 13.9998C9.50032 13.7243 9.724 13.4997 10.0005 13.4997C11.933 13.4997 13.4997 11.933 13.4997 10.0005C13.4997 8.06704 11.933 6.50032 10.0005 6.50032C8.06704 6.50032 6.50032 8.06704 6.50032 10.0005C6.50032 10.276 6.27568 10.4997 6.00016 10.4997C5.72368 10.4997 5.5 10.276 5.5 10.0005C5.5 7.51504 7.51504 5.5 10.0005 5.5C12.485 5.5 14.5 7.51504 14.5 10.0005C14.5 12.485 12.485 14.5 10.0005 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendingCircle);
export default __webpack_public_path__ + "static/media/icon-pending-circle.028057d0283260376fb271a3cb9934be.svg";
export { ForwardRef as ReactComponent };